"use client"

import { Tornado } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TornadoIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TornadoIcon = component(Icon)({ as: Tornado })
